var mp = mp || {};

// Form - Contact
//----------------------------------------------------------
mp.formValidationContact = function() {
    var $element = $('#form--contact');

    if (!$element.length) {
        return;
    }

    $element.validate({
        errorPlacement: function(error, element) {},
        ignore: ".ignore",
        rules: {
            "first_name": {
                required: true
            },
            "last_name": {
                required: true
            },
            "email": {
                required: true,
                email: true
            },
        },
        submitHandler: function(form) {
            mp.loadingOverlay("show");

            $.ajax({
                url: form.action,
                type: form.method,
                data: $(form).serialize(),
                success: function(response) {
                    if (response=="success") {
                        form.reset();

                        mp.loadingOverlay("hide");
                        mp.popupSuccess();
                    } else {
                        mp.loadingOverlay("hide");
                        mp.popupError();
                    }
                }            
            });
        }
    });
};



// Form - Visit Us
//----------------------------------------------------------
mp.formValidationVisitUs = function() {
    var $element = $('#form--visit-us');

    if (!$element.length) {
        return;
    }

    $element.validate({
        errorPlacement: function(error, element) {},
        ignore: ".ignore",
        rules: {
            "first_last_name": {
                required: true
            },
            "visit_date": {
                required: true
            },
            "visit_time": {
                required: true
            },
            "group_size": {
                required: true
            },
            "language": {
                required: true
            },
            "email": {
                required: true,
                email: true
            },
        },
        submitHandler: function(form) {
            mp.loadingOverlay("show");

            $.ajax({
                url: form.action,
                type: form.method,
                data: $(form).serialize(),
                success: function(response) {
                    if (response=="success") {
                        form.reset();

                        mp.loadingOverlay("hide");
                        mp.popupSuccess();
                    } else {
                        mp.loadingOverlay("hide");
                        mp.popupError();
                    }
                }            
            });
        }
    });
};




$(document).ready(function (){
    mp.formValidationContact();
    mp.formValidationVisitUs();
});




// Loading overlay
//-----------------------------------------------------------------
mp.loadingOverlay = function($action) {
    $html = '<div class="loader"><div class="spinner"></div></div>';

    if ($action == "show") {
        $('body').append($html);
    } else {
        $('.loader').remove();
    }
};